/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Doc_Group_ProcessingInputs */

const en_doc_group_processing = /** @type {(inputs: Doc_Group_ProcessingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Processing`)
};

const pt_br2_doc_group_processing = /** @type {(inputs: Doc_Group_ProcessingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Processando`)
};

/**
* | output |
* | --- |
* | "Processing" |
*
* @param {Doc_Group_ProcessingInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const doc_group_processing = /** @type {((inputs?: Doc_Group_ProcessingInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Doc_Group_ProcessingInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_doc_group_processing(inputs)
	return pt_br2_doc_group_processing(inputs)
});